import React, { useState } from 'react';
import { CloseOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import clsx from 'clsx';
import SearchInput from '../../components/ui/SearchInput';
import { categories as defaultCategories } from '../../constants';
import _ from 'lodash';

export const categoryNames = ['All Products', ...defaultCategories];

const categoriesList = _.sortBy(
  categoryNames.map((name) => ({
    id: name,
    name,
  })),
  'name'
);

const KioskSidebar = ({
  selectedCategories = [],
  activeCategory,
  toggleCategory,
  setActiveCategory,
  isSidebarOpen,
  onClose,
}) => {
  const [searchTerm, setSearchTerm] = useState('');

  const filteredCategories = categoriesList.filter((cat) =>
    cat.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const isSelected = (catId) => {
    if (Array.isArray(selectedCategories) && selectedCategories.length > 0) {
      return selectedCategories.some(
        (c) => c.toLowerCase() === catId.toLowerCase()
      );
    }
    if (typeof activeCategory === 'string') {
      return activeCategory.toLowerCase() === catId.toLowerCase();
    }
    return false;
  };

  const handleSelect = (catId) => {
    if (toggleCategory) {
      toggleCategory(catId);
    } else if (setActiveCategory) {
      setActiveCategory(catId);
    }
  };

  return (
    <div className={clsx('kiosk-sidebar', { open: isSidebarOpen })}>
      <div className="sidebar-header">
        <div className="sidebar-search-container">
          <SearchInput
            placeholder="Search categories..."
            className="sidebar-search-input w-full"
            value={searchTerm}
            onSearch={(val) => setSearchTerm(val)}
            delay={200}
            size="middle"
          />
        </div>
        {onClose && (
          <Button
            type="text"
            icon={<CloseOutlined style={{ fontSize: '18px', color: '#4B5563' }} />}
            onClick={onClose}
            className="sidebar-close-btn"
            title="Close categories"
          />
        )}
      </div>
      <div className="sidebar-categories-list">
        {filteredCategories.map((cat) => {
          const active = isSelected(cat.id);
          return (
            <div
              key={cat.id}
              className={clsx('category-item', { active })}
              onClick={() => handleSelect(cat.id)}
            >
              <span className="category-name">{cat.name}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default KioskSidebar;
